import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { SettingsAxios } from "../../axios/settings/settings.axios";
import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { UpdateUserSettingsDto } from "../../model/user/settings/dto/UpdateUserSettingsDto";
import { UserSettings } from "../../model/user/settings/types/UserSettings";
import { AtiraThunk } from "../AtiraThunk";
import { userActions } from "../user/user.slice";
import { revertAllReduxAction } from "../store-reset";

interface SettingsReducer {
  settings?: UserSettings;
}

const initialState = Object.freeze<SettingsReducer>({
  settings: undefined,
});

const updateSettings = AtiraThunk<void, UpdateUserSettingsDto>(
  `/settings/update`,
  SettingsAxios.updateSettings,
);

const getSettings = AtiraThunk<UserSettings, GenericWithUserId>(
  "/settings",
  SettingsAxios.getSettings,
);

const settingsSlice = createSlice({
  name: "task",
  initialState,
  reducers: {},
  extraReducers: ({ addCase, addMatcher }) => {
    addCase(getSettings.fulfilled, (state, action) => {
      state.settings = action.payload;
    });

    addMatcher(isAnyOf(userActions.logout, revertAllReduxAction), (state) => {
      return (state = initialState);
    });
  },
});

export const settingsActions = {
  ...settingsSlice.actions,
  updateSettings,
  getSettings,
};

export default settingsSlice.reducer;
